export const fieldsProducts = [
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'text-black text-capitalize py-1',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'product_variants',
    label: 'Variasi',
    thClass: 'text-black text-capitalize py-1 text-center',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'volume',
    label: 'Dimensi',
    thClass: 'text-black text-capitalize py-1 text-center',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
  },
  {
    key: 'packing_detail',
    label: 'Bahan Packing',
    thClass: 'text-black text-capitalize py-1 text-center',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      maxWidth: '260px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'is_product_bonus',
    label: 'Produk Bonus',
    thClass: 'text-black text-capitalize py-1 text-center',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      width: '160px',
    },
    tdClass: 'text-black',
  },
  {
    key: 'action',
    label: 'Aksi',
    thClass: 'text-black text-capitalize py-1 text-center',
    class: 'bg-white align-top',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
  },
]

export const fieldsBundling = [
  {
    key: 'no',
    label: 'No',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white',
    tdClass: 'text-black',
  },
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize bg-white',
    tdClass: 'text-black',
  },
  {
    key: 'qty',
    label: 'Jumlah',
    thClass: 'font-[500] text-[#222] !text-[14px] !capitalize text-center bg-white',
    tdClass: 'text-black text-center',
  },
]

export const storageRequestStatus = {
  diajukan: {
    label: 'Proses Pengajuan',
    color: 'text-[#FBA63C]',
    bgColor: 'bg-[#FCEBBE]',
  },
  disetujui: {
    label: 'Disetujui',
    color: 'text-[#34A770]',
    bgColor: 'bg-[#BEFCDE]',
  },
  ditolak: {
    label: 'Ditolak',
    color: 'text-[#E31A1A]',
    bgColor: 'bg-[#FCBEBE]',
  },
}
